import type { SlideChapterDefinition } from '@/components/SlideWizard'
import Slide0Title from './slides/Slide0Title'
import Slide1Insight from './slides/Slide1Insight'
// Slide1Thesis removed, Insight slide now carries the thesis + Peter's quote together
import Slide2TwoSpeeds from './slides/Slide2TwoSpeeds'
import Slide2FastMode from './slides/Slide2FastMode'
import Slide2Peter from './slides/Slide2Peter'
import Slide4TwoStages from './slides/Slide4TwoStages'
import Slide4Bridge from './slides/Slide4Bridge'
import Slide3Urgency from './slides/Slide3Urgency'
import Slide3Charity from './slides/Slide3Charity'
import Slide3TechSupport from './slides/Slide3TechSupport'
// Slide6Shame removed, saving for Chapter 5 (What To Do If Something Happens)
import Slide7Defense from './slides/Slide7Defense'
import Slide8Wrapup from './slides/Slide8Wrapup'

export const emotionalHijackChapter: SlideChapterDefinition = {
  id: 'emotional-hijack',
  title: 'The Emotional Hijack',
  description:
    'Learn how scammers use your emotions against you, and the one question that changes everything.',
  estimatedMinutes: 5,
  slides: [
    { id: 'eh-title', component: Slide0Title, label: 'Introduction' },
    { id: 'eh-peter', component: Slide2Peter, label: 'Peter\u2019s story' },
    { id: 'eh-insight', component: Slide1Insight, label: 'Why it works on everyone' },
    { id: 'eh-two-speeds', component: Slide2TwoSpeeds, label: 'Two speeds of thinking' },
    { id: 'eh-fast-mode', component: Slide2FastMode, label: 'Fast mode vs slow mode' },
    { id: 'eh-two-stages', component: Slide4TwoStages, label: 'Two stages of a scam' },
    { id: 'eh-bridge', component: Slide4Bridge, label: 'Spotting the pattern' },
    { id: 'eh-example', component: Slide3Urgency, label: 'Exercise: Urgency scam', requiresInteraction: true },
    { id: 'eh-example-2', component: Slide3Charity, label: 'Exercise: Charity scam', requiresInteraction: true },
    { id: 'eh-example-3', component: Slide3TechSupport, label: 'Exercise: Tech support scam', requiresInteraction: true },
    { id: 'eh-defense', component: Slide7Defense, label: 'Your best defence' },
    { id: 'eh-wrapup', component: Slide8Wrapup, label: 'Chapter summary' },
  ],
}
